import { FeedbackStateType } from "@type/index";
import { ActionsUnion, createAction } from "../helpers";

export const SET_FEED_BACK_MODAL_FLAG = "[feedback] SET_FEED_BACK_MODAL_FLAG";
export const SET_SELECT_RADIO_VALUE = "[feedback] SET_SELECT_RADIO_VALUE";
export const SET_CHECKBOX_IS_CHECKED = "[feedback] SET_CHECKBOX_IS_CHECKED";
export const SET_TEXTAREA_VALUE = "[feedback] SET_TEXTAREA_VALUE";
export const SET_VISUAL_SEARCH_REQ_RESULT =
  "[feedback] SET_VISUAL_SEARCH_REQ_RESULT";
export const SET_PRODUCT_REQ_RESULT = "[feedback] SET_PRODUCT_REQ_RESULT";
export const SET_IMAGE_FILE_DATA = "[feedback] SET_IMAGE_FILE_DATA";
export const SEND_UPLOADED_IMAGE = "[zero result] SEND UPLOADED IMAGE";
export const SET_UPLOADED_IMAGE_SUCCESS =
  "[zero result] SET_UPLOADED_IMAGE_SUCCESS";

export const Actions = {
  setFeedbackModal: (payload: boolean) =>
    createAction(SET_FEED_BACK_MODAL_FLAG, payload),
  setSelectRadioValue: (payload: any) =>
    createAction(SET_SELECT_RADIO_VALUE, payload),
  setCheckboxIsChecked: (payload: any) =>
    createAction(SET_CHECKBOX_IS_CHECKED, payload),
  setTextAreaValue: (payload: string) =>
    createAction(SET_TEXTAREA_VALUE, payload),
  setVisualSearchReqResult: (payload: string) =>
    createAction(SET_VISUAL_SEARCH_REQ_RESULT, payload),
  setProductReqResult: (payload: string) =>
    createAction(SET_PRODUCT_REQ_RESULT, payload),
  setImageFileData: (payload: any) =>
    createAction(SET_IMAGE_FILE_DATA, payload),
  sendUploadedImage: (payload: any): any =>
    createAction(SEND_UPLOADED_IMAGE, payload),
  setUploadedImageSuccess: (payload: boolean) =>
    createAction(SET_UPLOADED_IMAGE_SUCCESS, payload)
};

type ActionType = ActionsUnion<typeof Actions>;

const initialState: FeedbackStateType = {
  isVisibleFeedbackModal: false,
  visualSearchReqResult: "",
  productReqResult: "",
  questionnaireData: [
    {
      type: "radio",
      number: 1,
      question: "Are you satisfied with Image Search Result?",
      answer: null,
      options: [
        {
          label: "Very dissatisfied",
          value: "Very dissatisfied"
        },
        {
          label: "Dissatisfied",
          value: "Dissatisfied"
        },
        {
          label: "Neutral",
          value: "Neutral"
        },
        {
          label: "Satisfied",
          value: "Satisfied"
        },
        {
          label: "Very satisfied",
          value: "Very satisfied"
        }
      ]
    },
    {
      type: "radio",
      number: 2,
      question: "How often do you use Image Search?",
      answer: null,
      options: [
        {
          label: "Every day",
          value: "Every day"
        },
        {
          label: "Twice a week",
          value: "Twice a week"
        },
        {
          label: "Once a week",
          value: "Once a week"
        },
        {
          label: "Once a month",
          value: "Once a month"
        },
        {
          label: "Once half a year",
          value: "Once half a year"
        },
        {
          label: "First time use",
          value: "First time use"
        }
      ]
    },
    {
      type: "check box",
      number: 3,
      question: "What is your expection of using Image Search?",
      options: [
        {
          label: "To find the exact same item",
          value: "To find the exact same item"
        },
        {
          label: "To find similar item",
          value: "To find similar item"
        },
        {
          label: "To find discount item",
          value: "To find discount item"
        },
        {
          label: "To find item in same colour",
          value: "To find item in same colour"
        },
        {
          label: "To find similar outfit",
          value: "To find similar outfit"
        }
      ]
    },
    {
      type: "radio",
      number: 4,
      question: "How often do you get your expected result?",
      answer: null,
      options: [
        {
          label: "Every time",
          value: "Every time"
        },
        {
          label: "Most of time",
          value: "Most of time"
        },
        {
          label: "Half-half",
          value: "Half-half"
        },
        {
          label: "Rarely",
          value: "Rarely"
        },
        {
          label: "Never",
          value: "Never"
        }
      ]
    },
    {
      type: "check box",
      number: 5,
      question: "Why do you think the result is unexpected?",
      options: [
        {
          label: "Item style does not match",
          value: "Item style does not match"
        },
        {
          label: "Item colour does not match",
          value: "Item colour does not match"
        },
        {
          label: "Item category does not match",
          value: "Item category does not match"
        },
        {
          label: "Outfit style does not match",
          value: "Outfit style does not match"
        },
        {
          label: "Cannot find anything",
          value: "Cannot find anything"
        }
      ]
    },
    {
      type: "textarea",
      number: 6,
      question: "Please let us know more suggestion/expected feature",
      answer: "",
      options: []
    }
  ],
  image_file: null,
  isUploadedImageSuccess: false
};

export default (
  state: FeedbackStateType = initialState,
  action: ActionType
): FeedbackStateType => {
  switch (action.type) {
    case SET_FEED_BACK_MODAL_FLAG: {
      return { ...state, isVisibleFeedbackModal: action.payload };
    }
    case SET_SELECT_RADIO_VALUE: {
      const _questionnaireData = JSON.parse(
        JSON.stringify(state.questionnaireData)
      );
      const _temp = _questionnaireData[action.payload.index];
      _temp.answer = action.payload.value;
      return { ...state, questionnaireData: _questionnaireData };
    }
    case SET_CHECKBOX_IS_CHECKED: {
      return { ...state, questionnaireData: action.payload };
    }
    case SET_TEXTAREA_VALUE: {
      const _questionnaireData = JSON.parse(
        JSON.stringify(state.questionnaireData)
      );
      const _textarea = _questionnaireData[5];
      _textarea.answer = action.payload;
      return { ...state, questionnaireData: _questionnaireData };
    }
    case SET_VISUAL_SEARCH_REQ_RESULT: {
      return { ...state, visualSearchReqResult: action.payload };
    }
    case SET_PRODUCT_REQ_RESULT: {
      return { ...state, productReqResult: action.payload };
    }
    case SET_IMAGE_FILE_DATA: {
      return { ...state, image_file: action.payload };
    }
    case SET_UPLOADED_IMAGE_SUCCESS: {
      return { ...state, isUploadedImageSuccess: action.payload };
    }
    default:
      return state;
  }
};
